export const DataImportProjectUtil = {
  projectSeqId: (seq: number) => `DBPJ${seq.toString().padStart(3, "0")}`,

  nameWithSeqId: (project: { seq: number; name: string }) =>
    `${DataImportProjectUtil.projectSeqId(project.seq)} ${project.name}`,

  nameWithoutYear: (name: string) => name.replace(/^(\d{4}\/)/, ""),

  dataSource: {
    defaultName: (project: { seq: number; name: string }, numDataSources: number) =>
      `${DataImportProjectUtil.projectSeqId(project.seq)}-${
        numDataSources + 1
      }_${DataImportProjectUtil.nameWithoutYear(project.name)}`,
  },

  startStatusId: () => "Planning",
  completeStatusId: () => "Done",

  orderedStatusIds: [
    "Inbox",
    "Planning",
    "DataInput",
    "EvidenceImport",
    "ERComposition",
    "DataApproval",
    "Done",
  ] as const,
};
